import React from 'react';
import About from '../components/About';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <About />
    </div>
  );
};

export default AboutPage;
